import { getJobPickerState, setJobsMode, setTemplateMode } from "utilities/jobPicker/jobPicker";
import {
    jobModeParamValue,
    jobPickerModeParam,
    templateModeParamValue,
} from "utilities/jobPicker/openTemplateUrl";

/**
 * Switches this tab's job picker to the mode named by the `jobPickerMode` flag (`template` or
 * `job`), on any route, then removes the flag from the address bar. Imported for its side effect
 * from `index-app.tsx` so it runs once, before the router and the job picker read anything.
 *
 * Switching mode clears the selection, since it belonged to the other mode. A picker already in
 * the requested mode keeps its selection.
 *
 * Exported for tests. The module-level call below is the single production caller.
 */
export function applyJobPickerModeFromUrl(): void {
    const url = new URL(window.location.href);
    const mode = url.searchParams.get(jobPickerModeParam);
    if (mode !== templateModeParamValue && mode !== jobModeParamValue) {
        return;
    }

    url.searchParams.delete(jobPickerModeParam);
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);

    const wantsTemplateMode = mode === templateModeParamValue;
    if (getJobPickerState().isTemplateMode === wantsTemplateMode) {
        return;
    }

    if (wantsTemplateMode) {
        setTemplateMode();
    } else {
        setJobsMode();
    }
}

applyJobPickerModeFromUrl();
